import {HttpServiceResponse} from 'vue3-starter/src/typescript/http/http';
import {context} from 'vue3-starter/src/typescript/app-context/AppContext';

export type SuggestedTag = {
    tag: string,
}

export type TagSuggestion = {
    tag: string,
    label: string,
    occurrences: number,
    universe: string,
}

export class FreelancerTagsService {
    async retrieveSuggestions(category: string): Promise<HttpServiceResponse<SuggestedTag[]>> {
        const suggestTagsUrl = context.registry.entries.suggestTags().replace('category=', `category=${category}`);
        return await context.httpService.get<SuggestedTag[]>(suggestTagsUrl);
    }

    async autocomplete(query: string): Promise<HttpServiceResponse<TagSuggestion[]>> {
        const autocompleteTagsUrl = context.registry.entries.autocompleteTags().replace('query=', `query=${query}`);
        return await context.httpService.get<TagSuggestion[]>(autocompleteTagsUrl);
    }
}
